<template>
  <el-dropdown
    size="mini"
    trigger="click"
    class="float-right"
    @command="setOperator"
  >
    <span class="text-muted text-lowercase font-weight-lighter">
      {{ filterable.filter.operator.label }}<i class="el-icon-arrow-down el-icon--right" />
    </span>

    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="(operator, index) in operators"
        :key="index"
        :command="operator"
      >
        {{ operator.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Resource from '@/plugins/sdk/Resource'
import {
  BEGINS_WITH,
  CONTAINS,
  DOES_NOT_BEGIN_WITH,
  DOES_NOT_CONTAIN,
  DOES_NOT_END_IN,
  DOES_NOT_EQUAL,
  ENDS_IN,
  EQUALS,
  IS,
  IS_BETWEEN,
  IS_EMPTY,
  IS_FALSE,
  IS_GREATER_THAN,
  IS_LESS_THAN,
  IS_NOT,
  IS_NOT_BETWEEN,
  IS_TRUE
} from '@/plugins/sdk/operators'

export default {
  props: {
    resource: {
      type: [ Object, Function ],
      required: true
    },
    filterable: {
      type: Object,
      required: true
    }
  },
  computed: {
    /**
     * Returns an instance of the resources field relative to the
     * filters active field.
     */
    resourceField () {
      let resource = this.resource
      let field

      if (typeof this.filterable.filter.field !== 'undefined') {
        this
          .filterable
          .filter
          .field
          .split('.')
          .map(f => {
            if (resource instanceof Resource) {
              field = resource.constructor.fields[f]
            } else if (resource.prototype instanceof Resource) {
              field = resource.fields[f]
            }

            resource = field._resource || resource
          })
      }

      return field
    },
    /**
     * Computes the filter operators that are compatible with
     * the given resource field instance.
     */
    operators () {
      if (this.filterable.operators.length) {
        return [
          IS,
          CONTAINS,
          DOES_NOT_CONTAIN,
          IS_NOT,
          BEGINS_WITH,
          DOES_NOT_BEGIN_WITH,
          ENDS_IN,
          DOES_NOT_END_IN,
          EQUALS,
          DOES_NOT_EQUAL,
          IS_BETWEEN,
          IS_NOT_BETWEEN,
          IS_GREATER_THAN,
          IS_LESS_THAN,
          IS_TRUE,
          IS_FALSE,
          IS_EMPTY
        ].filter(operator => this.filterable.operators.includes(operator.label))
      } else if (Object.keys(this.filterable.options).length > 0) {
        // If the filterable predefines selectable options
        // enforce the is and is not operators.
        return [ IS, IS_NOT ]
      } else {
        // Return an array of operators that declare compatibility
        // with the resource field.
        return [
          CONTAINS,
          DOES_NOT_CONTAIN,
          IS,
          IS_NOT,
          BEGINS_WITH,
          DOES_NOT_BEGIN_WITH,
          ENDS_IN,
          DOES_NOT_END_IN,
          EQUALS,
          DOES_NOT_EQUAL,
          IS_BETWEEN,
          IS_NOT_BETWEEN,
          IS_GREATER_THAN,
          IS_LESS_THAN,
          IS_TRUE,
          IS_FALSE,
          IS_EMPTY
        ].filter(operator => !!operator.fields.find(field => this.resourceField instanceof field))
      }
    }
  },
  created () {
    if (typeof this.filterable.filter.operator === 'undefined') {
      // If the filter has not declared an operator make sure
      // that the first compatible operator is selected.
      this.filterable.filter.operator = this.operators[0]
    }
  },
  methods: {
    /**
     * Sets the operator of the filter.
     *
     * @param      {Object}  operator  The operator
     */
    setOperator (operator) {
      this.filterable.filter.operator = operator
    }
  }
}
</script>
